'use client';

import Image, { ImageProps } from 'next/image';
import { useState } from 'react';

const fallbackImageSrc = '/images/empty_bg_small.svg';

function normalizeImageSrc(src: ImageProps['src']) {
  if (typeof src !== 'string') return src;

  const trimmedSrc = src.trim();
  if (!trimmedSrc) return fallbackImageSrc;
  if (trimmedSrc.startsWith('/')) return trimmedSrc;
  if (trimmedSrc.startsWith('//')) return `https:${trimmedSrc}`;

  try {
    const url = new URL(trimmedSrc);
    return ['http:', 'https:'].includes(url.protocol)
      ? trimmedSrc
      : fallbackImageSrc;
  } catch {
    return `/${trimmedSrc}`;
  }
}

const ImageOptimizer = ({ loading, priority, ...props }: ImageProps) => {
  const [error, setError] = useState(false);
  const src = normalizeImageSrc(props.src);

  // 기본은 lazy 유지. 단 호출부가 priority(LCP 이미지)나 loading 을 지정하면 존중한다.
  // next/image 는 priority 와 loading 을 함께 주면 안 되므로 둘 중 하나만 넘긴다.
  const loadingProps = priority
    ? { priority: true }
    : { loading: loading ?? ('lazy' as const) };

  return (
    <Image
      {...props}
      {...loadingProps}
      src={!error ? src : fallbackImageSrc}
      alt={props.alt || '이미지 없음'}
      onError={() => setError(true)}
    />
  );
};

export default ImageOptimizer;
